import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/companymessage/companyMessage/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/companymessage/companyMessage/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/companymessage/companyMessage/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/companymessage/companyMessage/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/companymessage/companyMessage/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/companymessage/companyMessage/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/companymessage/companyMessage/import',
      method: 'post',
      data: data
    })
  }
}
